import { Base } from "ui/Scripts/source/framework/base";
import { ListItems } from "ui/Scripts/source/framework/listItems";
import { ITaskStateListItem, TaskStateListItem } from "./taskStateListItem";

export interface ITaskStateListItems extends ListItems<ITaskStateListItem> {
}

export class TaskStateListItems extends ListItems<TaskStateListItem> implements ITaskStateListItems {
    constructor();
    constructor(obj: ITaskStateListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, TaskStateListItem);
    }
}